import { Badge } from "@mindstonehq/ui";
import type { CoachingSignals } from "~/lib/coaching-signals-types";
import type { CommunitySignals } from "~/lib/community-signals-types";
import {
  deriveRoleChips,
  type CertificateGroup,
} from "~/lib/profile-celebration";

export default function ProfileHeroChips({
  signals,
  coaching,
  certificateGroups,
}: {
  signals: CommunitySignals | null;
  coaching: CoachingSignals | null;
  certificateGroups: readonly CertificateGroup[];
}) {
  const chips = deriveRoleChips(signals, coaching, certificateGroups);
  if (chips.length === 0) return null;

  return (
    <div
      className="flex flex-wrap justify-center gap-2 sm:justify-start"
      aria-label="Verified profile roles"
    >
      {chips.map((chip) => (
        <Badge key={chip.key} variant={chip.variant}>
          {chip.label}
        </Badge>
      ))}
    </div>
  );
}
